import { Check, Copy, Sparkles } from "lucide-react";
import { ImageWithFallback } from "@/app/shared/ui";
import type { FeaturedPromptCardProps } from "../types";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";
import { Button } from "@/app/core/ui/neitral.ui/button";

export function FeaturedPromptCard({ example, copied, onCopy, onSelect }: FeaturedPromptCardProps) {
  const { t } = useTranslation();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(example.prompt)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect(example.prompt);
        }
      }}
      className="group w-full overflow-hidden rounded-3xl border text-left bg-card border-border transition"
    >
      {example.type === "image" && example.imageUrl ? (
        <div className="relative aspect-[16/10] overflow-hidden">
          <ImageWithFallback src={example.imageUrl} alt={example.prompt} className="h-full w-full object-cover transition duration-300 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        </div>
      ) : null}

      <div className="p-5">
        <div className="mb-3 flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-muted">
            <Sparkles className="h-4 w-4 text-accent" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold leading-6 text-foreground">{example.prompt}</div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            aria-label={t('copyPrompt')}
            onClick={(event) => {
              event.stopPropagation();
              onCopy(example.prompt, example.id);
            }}
            className="rounded-xl bg-muted hover:bg-muted/80"
          >
            {copied ? <Check className="h-4 w-4 text-accent" /> : <Copy className="h-4 w-4 text-foreground" />}
          </Button>
        </div>
        {example.type === "text" && example.result ? (
          <p className="text-sm leading-6 text-muted-foreground">{example.result}</p>
        ) : null}
      </div>
    </div>
  );
}